// extracted by mini-css-extract-plugin
export var anchor = "_30-0";
export var discard = "_30-4";
export var muiTooltipTooltip = "_30-6";
export var notificationBar = "_30-3";
export var saveButtonHoverSlotWrapper = "_30-5";
export var show = "_30-2";
export var spacer = "_30-1";